import React, { useState, Fragment } from 'react';
import { inject, observer } from 'mobx-react';
import { PrimaryButton, DotLoader } from "@myplay/ui";

import { capitalize } from '../../utils/stringManipulations';
import { ORANGE, ORANGE_LIGHT, WHITE, BLACK } from '../../styles/colors';
import I18N from '../../I18N';

const YoutubeUpload = ({ onChange, youtubeLink, onBack, VideosStore, onUploadApprove }) => {
  const [videoInfo, setVideoInfo] = useState(null);
  const [link, setLink] = useState(null);
  const [inputValue, setInputValue] = useState(null);
  const [error, setError] = useState("");

  const handleUpload = async () => {
    const isValid = validateYouTubeLink();

    if(!isValid) {
      setError(capitalize(I18N.t("YOUTUBE_URL_ERROR")));
      return;
    }

    if (!videoInfo && isValid) {
      setError("");
      setLink(inputValue);
      const info = await VideosStore.validateYoutubeLink(inputValue);
      setVideoInfo(info);
      return;
    }

    onUploadApprove(link);
  };

  const handleBack = ()=> {
    if (link) {
      setError("");
      setLink(null);
      setVideoInfo(null);
      return;
    }
    onBack();
  }

  const validateYouTubeLink = () => {
    const regExp = /^.*(youtube\/|v\/|u\/\w\/|embed\/|watch\?v=|\&v=|\?v=|\?vi=)([^#\&\?]*).*/;
    const match = inputValue.match(regExp);

    return match && match[2].length === 11;
  }

  return (
    <div className="upload-video-modal__youtube-modal" data-testid="youtube-modal">
      {!link ?
        <Fragment>
          <span>{capitalize(I18N.t("UPLOAD_VIDEO_TO_TEAM_CHANNEL"))}</span>
          <input
            type="text"
            onChange={event => setInputValue(event.target.value)}
            placeholder={`${capitalize(I18N.t("PASTE_LINK"))}...`}
            data-testid="youtube-input"
          />
          <span className="upload-video-modal__youtube-modal__error" style={{ color: "yellow" }}>{error}</span> 
        </Fragment> :
        <Fragment>
          {!videoInfo ?
            <DotLoader /> :
            <div className="upload-video-modal__youtube-modal__video-info">
              <span>{videoInfo ? videoInfo.title : ""}</span>
              <img src={videoInfo.thumbnail} alt="" style={{ height: "300px", width: "450px" }}/>
              <span>{capitalize(I18N.t("IS_THIS_YOUR_VIDEO"))}</span>
            </div>
          }
        </Fragment>
      }
      <div className="upload-video-modal__youtube-modal__buttons">
        <PrimaryButton
          color={WHITE}
          background={BLACK}
          onClick={handleBack}
          showBorder
        >
          {link ? capitalize(I18N.t("NO")) : capitalize(I18N.t("BACK"))}
        </PrimaryButton>
        <PrimaryButton
          color={WHITE}
          background={inputValue ? ORANGE : ORANGE_LIGHT}
          onClick={handleUpload}
          data-testid="youtube-upload"
        >
          {link ? capitalize(I18N.t("YES")) : capitalize(I18N.t("UPLOAD"))}
        </PrimaryButton>
      </div>
    </div>
  );
};

export default inject("VideosStore")(observer(YoutubeUpload));